import { DatePipe } from '@angular/common';
import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'dateAgo',
    pure: false
})
export class DateAgoPipe extends DatePipe implements PipeTransform {

    override transform(value: any, args?: any): any {
        if (value) {
            const seconds = Math.floor((+new Date() - +new Date(value)) / 1000);
            if(seconds < 86400) {
                return super.transform(value, "h:mm a");
            } else {
                return super.transform(value, "MM/dd/yy, h:mm a");
            }
            // if (seconds < 29) // less than 30 seconds ago will show as 'Just now'
            //     {return 'Just now';}
            // const intervals: any = {
            //     year: 31536000,
            //     month: 2592000,
            //     week: 604800,
            //     day: 86400,
            //     hour: 3600,
            //     minute: 60,
            //     second: 1
            // };
            // let counter;
            // // eslint-disable-next-line guard-for-in
            // for (const i in intervals) {
            //     counter = Math.floor(seconds / intervals[i]);
            //     if (counter > 0)
            //         {if (counter === 1) {
            //             return counter + ' ' + i + ' ago'; // singular (1 day ago)
            //         } else {
            //             return counter + ' ' + i + 's ago'; // plural (2 days ago)
            //         }}
            // }
        }
        return value;
    }

}
